module.exports = __webpack_public_path__ + "img/GT.ff603e98.svg";